import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

function AddSubModules() {
  return (
    <>
      <div className="container-fluid p-5 div-ContainerFluid">
        <div className="row bg-white">
          <div className="col-12">
            <div className="div-borderlines p-4">
              <h4 className="fw-bold h4-agduaxjcgshtusa gap-1 mb-3">
                Sub-Modules Details
              </h4>
              <div className="div-dropdown">
                <p className="p-aijdshfdsaa">Module </p>
                <select
                  class="form-select div-dsfuidsdygfis"
                  aria-label="Default select example"
                >
                  <option selected>Module</option>
                  <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </select>
              </div>

              <div>
                <p className="fw-bold h4-schsujsugcsj gap-1">
                  Sub-Module Details{" "}
                </p>
                <div>

                  <Form className="form-scacaz w-50">
                    <p className="mb-3">Sub-Module name</p>
                    <input type="text" className="" placeholder="Level-5" />
                  </Form>

                </div>

                <div>

                <Form className="form-scacaz w-50">
                    <p className="mb-3">Start Date</p>
                    <input type="text" className="" placeholder="Dec 10, 2024" />
                  </Form>
                </div>

                <div>
                <Form className="form-scacaz w-50">
                    <p className="mb-3">End Date</p>
                    <input type="text" className="" placeholder="Jan 30, 2025" />
                  </Form>
                </div>

                <div>
                <Form className="form-scacaz w-50">
                    <p className="mb-3">Status</p>
                    <input type="text" className="" placeholder="Active" />
                  </Form>
                </div>

                <div className="btndiv">
                  <div className="d-flex align-items-center gap-2">
                    <button type="button" class="div-ButtonGreen">
                      Add Module
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddSubModules;
